import { useCallback, useEffect } from 'react';

const fns = new Set();

export const loop = timestamp => {
  for (const fn of fns.values()) {
    fn(timestamp);
  }
};

export default function useRaf(fn, deps = []) {
  const render = useCallback(fn, deps);

  useEffect(() => {
    fns.add(render);
    return () => fns.delete(render);
  }, [render]);
};
